import { Container, Navbar, Dropdown } from "react-bootstrap";
import Logo from "../../assets/images/just_breathe_white_logo.svg";
import avtar from "../../assets/images/default-avatar.jpg";
import { GoChevronDown } from "react-icons/go";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { BiLogOutCircle } from "react-icons/bi";
import { SlUser } from "react-icons/sl";
import { FcRules } from "react-icons/fc";

import { useSelector } from "react-redux";
import { MdOutlinePolicy } from "react-icons/md";
import { BsFileEarmarkRuled } from "react-icons/bs";
import { useEffect, useState } from "react";
const Header = () => {
  const navigate = useNavigate();
  const [userName, setUserName] = useState(localStorage.getItem("name"));
  const userEmail = localStorage.getItem("email");
  const [profileImage, setProfileImage] = useState(
    localStorage.getItem("profileImage")
  );

  useEffect(() => {
    const handleNameUpdated = (event: Event) => {
      const customEvent = event as CustomEvent;
      setUserName(localStorage.getItem("name"));
    };

    const handleImageUpdated = (event: Event) => {
      const customEvent = event as CustomEvent;
      setProfileImage(localStorage.getItem("profileImage"));
    };

    window.addEventListener("name_updated", handleNameUpdated);
    window.addEventListener("image_updated", handleImageUpdated);

    return () => {
      window.removeEventListener("name_updated", handleNameUpdated);
      window.removeEventListener("image_updated", handleImageUpdated);
    };
  }, []);
  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("name");
    localStorage.removeItem("email");
    localStorage.removeItem("companyId");
    localStorage.removeItem("userId");
    localStorage.removeItem("profileImage");
    toast.success("Logged out successfully!");
    navigate("/login");
  };

  return (
    <>
      <header className="site-header">
        <Container fluid className="header-nav">
          <Navbar expand="lg">
            <Navbar.Brand className="me-5">
              <img src={Logo} width={180} alt="" />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <div className="d-flex align-items-center ms-auto gap-3">
              <Dropdown className="profile-dd">
                <Dropdown.Toggle
                  variant="light"
                  style={{
                    backgroundColor: "white !important",
                    border: "1px solid #e3e6f0",
                    borderRadius: "8px",
                    padding: "8px 12px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                    color: "#212529",
                  }}
                >
                  <div className="d-flex gap-2">
                    <div>
                      <img
                        src={profileImage ?? avtar}
                        width={35}
                        height={35}
                        className=" rounded-circle object-fit-cover"
                        alt=""
                        onError={(e) => {
                          (e.target as HTMLImageElement).src =
                           avtar;
                        }}
                      />
                    </div>
                    <div>
                      <p className="font-14 mb-0 text-dark font-medium">
                        {userName}
                      </p>
                      <p className="font-12 mb-0 text-secondary">{userEmail}</p>
                    </div>
                  </div>
                  <GoChevronDown size={16} className="icon" />
                </Dropdown.Toggle>
                <Dropdown.Menu align="end">
                  <Link to="/profile" className=" dropdown-item">
                    <SlUser size={14} className="me-2" /> My Profile
                  </Link>
                  <Link
                    to="javascript:void(0)"
                    onClick={() => {
                      window.open(
                        "https://control.justbreathe.in/terms-and-conditions",
                        "_blank"
                      );
                    }}
                    className=" dropdown-item"
                  >
                    <BsFileEarmarkRuled size={16} className="me-2" /> Terms &
                    Condition
                  </Link>
                  <Link
                    to="javascript:void(0)"
                    className=" dropdown-item"
                    onClick={() => {
                      window.open(
                        "https://justbreathe.in/privacy-notice",
                        "_blank"
                      );
                    }}
                  >
                    <MdOutlinePolicy size={16} className="me-2" /> Privacy
                    Policy
                  </Link>
                  <Dropdown.Item onClick={handleLogout}>
                    <BiLogOutCircle className="me-2" />
                    Logout
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </Navbar>
        </Container>
      </header>
    </>
  );
};
export default Header;
